export const sessionError = "A problem was encountered. Please try again." as const
